import * as Yup from 'yup'

export const initialCreateFormValues = {
    first_name: "",
    last_name: "",
    company_name: "",
    license_number: "",
    email: "",
    address: "",
    address1: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    phone: "",
    mobile: "",
    fax: ""
}

export const formValidationSchema = Yup.object({
    first_name: Yup.string().required("This field is required"),
    last_name: Yup.string().required("This field is required"),
    company_name: Yup.string().required("This field is required"),
    license_number: Yup.string().required("This field is required"),
    email: Yup.string().required("This field is required"),
})
